import React from 'react';
import ContentLoader from 'react-content-loader';

const HomeContentLoader = () => (
    <ContentLoader
        speed={2}
        width="100%"
        height={700}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        viewBox="0 0 1200 700"
    >
        {/* Top Navbar */}
        <rect x="30" y="20" rx="8" ry="8" width="80" height="30" /> {/* Home */}
        <rect x="120" y="20" rx="8" ry="8" width="80" height="30" />
        <rect x="210" y="20" rx="8" ry="8" width="80" height="30" />
        <rect x="300" y="20" rx="8" ry="8" width="80" height="30" />
        <rect x="1050" y="20" rx="16" ry="16" width="100" height="35" /> {/* Login */}

        {/* Hero Banner (image and text) */}
        <rect x="30" y="80" rx="10" ry="10" width="1140" height="250" /> {/* Image */}
        <rect x="50" y="350" rx="4" ry="4" width="800" height="20" /> {/* Banner Text Line 1 */}
        <rect x="50" y="380" rx="4" ry="4" width="650" height="20" /> {/* Banner Text Line 2 */}

        {/* Section Title */}
        <rect x="30" y="430" rx="6" ry="6" width="400" height="28" /> {/* About Krushak... */}

        {/* Four Cards (Schemes, Advisory, etc.) */}
        <rect x="30" y="480" rx="10" ry="10" width="1140" height="50" />
        <rect x="30" y="540" rx="10" ry="10" width="1140" height="50" />
        <rect x="30" y="600" rx="10" ry="10" width="1140" height="50" />
        <rect x="30" y="660" rx="10" ry="10" width="1140" height="50" />
    </ContentLoader>
);

export default HomeContentLoader;
